import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout.vue'
import NoResult from './components/404.vue'
import Home from './views/home.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'pc',
      component: Layout,
      redirect: { name: 'home' },
      children: [
        { path: 'home', name: 'home', component: Home },
        { path: 'shop', name: 'shop', component: () => import('./views/shop.vue') },
        { path: 'shop/result', name: 'shop-success', component: () => import('./views/shop/result.vue') },
        { path: 'about', name: 'about', component: () => import('./views/about.vue') },
        { path: 'disclaimer', name: 'disclaimer', component: () => import('./views/disclaimer.vue') },
        { path: 'legal/:item', name: 'legal', component: () => import('./views/legalPrivacy.vue') },
        { path: 'company_info_share', name: 'companyInfoShare', component: () => import('./views/companyInfo.vue') }
      ]
    },
    {
      path: '*',
      name: 'NoResult',
      component: Layout,
      redirect: { name: 'NoResult' },
      children: [
        { path: '', name: 'NoResult', component: NoResult }
      ]
    }
  ]
})

export default router
